import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 pt-3 font-catering-body" }
const _hoisted_2 = { class: "overflow-hidden rounded-catering-md border border-catering-cream-400" }
const _hoisted_3 = { class: "flex items-center gap-3 border-b border-catering-cream-400 bg-catering-cream-100 p-3.5" }
const _hoisted_4 = {
  key: 0,
  class: "p-3.5"
}
const _hoisted_5 = {
  key: 1,
  class: "p-3.5"
}
const _hoisted_6 = {
  key: 2,
  class: "p-3.5"
}
const _hoisted_7 = {
  key: 0,
  class: "m-0 mt-2.5 rounded-catering-xs border border-catering-cream-400 bg-catering-cream-100 p-2.5 text-sm leading-relaxed text-catering-ink-700"
}
const _hoisted_8 = {
  key: 1,
  class: "m-0 mt-2.5 text-sm leading-relaxed text-catering-ink-600"
}
const _hoisted_9 = { class: "m-0 grid list-none gap-2.5 p-3.5" }
const _hoisted_10 = {
  key: 0,
  class: "m-0 text-sm text-catering-berry-600"
}
const _hoisted_11 = { class: "flex flex-wrap items-center justify-end gap-3 pt-1" }

import Cookies from 'js-cookie'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'

import GlowFrame from '@/components/catering/GlowFrame.vue'
import Pill from '@/components/catering/Pill.vue'
import SwooshArrow from '@/components/catering/SwooshArrow.vue'
import NeueButton from '@/components/neue/NeueButton.vue'
import {
  PAYMENTS_STEP,
  paymentsStepFromStatus,
  stepStatus,
  STRIPE_ACTION_REQUIRED,
  STRIPE_CONNECTED,
  STRIPE_NOT_CONNECTED,
  STRIPE_PENDING,
  useSetupState
} from '@/composables/setupState'
import api from '@/store/api'

const STRIPE_BUTTON_CLASS =
  'w-full cursor-pointer rounded-full border-none bg-[#635BFF] px-5 py-2.5 font-catering-body text-[15px] font-semibold text-white transition-colors hover:bg-[#5249F0]'


export default {
  __name: 'SetupPaymentsStep',
  props: {
  data: { type: Object, default: () => ({}) },
  complete: { type: Boolean, default: false }
},
  emits: ['done'],
  setup(__props) {

const ASKS = [
  'Your business details and the person responsible for it',
  'A bank account for your payouts',
  'An identity check, usually instant'
]

const STATUSES = [STRIPE_NOT_CONNECTED, STRIPE_PENDING, STRIPE_ACTION_REQUIRED, STRIPE_CONNECTED]

const PILL_TONES = { done: 'success', pending: 'warning', attention: 'tomato', todo: 'neutral' }

const props = __props


const { applyStep } = useSetupState((...args) => api.call(...args))

const refreshStripe = async () => {
  const response = await api.call('POST', 'setup/stripe_refresh', {}, { receive: false, redirectOnForbidden: false })
  applyStep(paymentsStepFromStatus(response.data?.status, response.data?.action_required_reason))
}

const checking = ref(false)
const checkError = ref('')
const awaiting = ref(false)

const status = computed(() => {
  if (STATUSES.includes(props.data.status)) return props.data.status
  return props.complete ? STRIPE_CONNECTED : STRIPE_NOT_CONNECTED
})
// Stripe's own wording, printed as it came: it names the field it could not
// verify, and anything we wrote instead would send the merchant back guessing.
const reason = computed(() => {
  const given = props.data.action_required_reason
  return typeof given === 'string' ? given.trim() : ''
})
const statusEntry = computed(() => stepStatus({ key: PAYMENTS_STEP, complete: props.complete, data: props.data }))
const statusLabel = computed(() => statusEntry.value.label)
const statusTone = computed(() => PILL_TONES[statusEntry.value.tone] || 'neutral')

const check = async () => {
  if (checking.value) return
  checking.value = true
  checkError.value = ''
  try {
    await refreshStripe()
    awaiting.value = false
  } catch {
    checkError.value = 'We could not reach Stripe just now. Try again in a moment.'
  } finally {
    checking.value = false
  }
}

const connect = () => {
  const base = process.env.VUE_APP_API_BASE_SERVER || (process.env.VUE_APP_API_SERVER || '').replace('/dashboard/', '/')
  const opened = window.open(`${base}express/redirect?state=${Cookies.get('auth_token')}`, '_blank')
  if (!opened) {
    checkError.value = 'Your browser blocked the Stripe tab. Allow pop-ups for this site and try again.'
    return
  }
  checkError.value = ''
  awaiting.value = true
}

const onVisibilityChange = () => {
  if (document.visibilityState === 'visible' && awaiting.value) check()
}

onMounted(() => document.addEventListener('visibilitychange', onVisibilityChange))
onBeforeUnmount(() => document.removeEventListener('visibilitychange', onVisibilityChange))

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "m-0 text-sm leading-relaxed text-catering-ink-600" }, " Bottle uses Stripe to take card payments and pay them into your bank. It is the one part of setup nobody can do for you. ", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("span", {
          class: "grid h-9 w-9 flex-shrink-0 place-items-center rounded-catering-xs bg-[#635BFF] font-manrope text-lg font-extrabold text-white",
          "aria-hidden": "true"
        }, " S ", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "min-w-0 flex-1" }, [
          _createElementVNode("span", { class: "block text-sm font-semibold text-catering-ink-900" }, "Stripe connected account"),
          _createElementVNode("span", { class: "block text-xs text-catering-ink-500" }, "Card payments and daily payouts")
        ], -1)),
        _createVNode(Pill, {
          tone: statusTone.value,
          size: "sm",
          dot: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(statusLabel.value), 1)
          ]),
          _: 1
        }, 8, ["tone"])
      ]),
      (status.value === _unref(STRIPE_CONNECTED))
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[3] || (_cache[3] = [
            _createElementVNode("p", { class: "m-0 text-sm leading-relaxed text-catering-ink-600" }, " Cards are live at checkout and your payouts are on their way to your bank on every business day. ", -1)
          ]))]))
        : (status.value === _unref(STRIPE_PENDING))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("p", { class: "m-0 text-sm leading-relaxed text-catering-ink-600" }, " Stripe has your details and is checking them. This is the normal path, not a problem: it usually clears within a day and there is nothing for you to do. This step ticks itself the moment Stripe is happy. ", -1)
            ]))]))
          : (status.value === _unref(STRIPE_ACTION_REQUIRED))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[5] || (_cache[5] = _createElementVNode("p", { class: "m-0 text-sm leading-relaxed text-catering-ink-600" }, " Stripe has your details but needs something more from you before it can turn payments on. It waits for you, so this one does not clear on its own. ", -1)),
                (reason.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(reason.value), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_8, " Stripe has not told us which detail it is. Open your Stripe account and it will show you what is missing. ")),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass([STRIPE_BUTTON_CLASS, 'mt-3.5']),
                  onClick: connect
                }, "Finish on Stripe", 2),
                _cache[6] || (_cache[6] = _createElementVNode("p", { class: "m-0 mt-2.5 text-xs leading-relaxed text-catering-ink-500" }, " Opens Stripe in a new tab. Checkout stays closed until Stripe has what it asked for, so no orders can reach you before then. ", -1))
              ]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("ul", _hoisted_9, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ASKS, (item) => {
                    return _createElementVNode("li", {
                      key: item,
                      class: "flex gap-2.5 text-sm leading-snug text-catering-ink-600"
                    }, [
                      _cache[7] || (_cache[7] = _createElementVNode("span", {
                        class: "mt-0.5 h-4 w-4 flex-shrink-0 rounded-catering-xs border-[1.5px] border-catering-cream-500",
                        "aria-hidden": "true"
                      }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(item), 1)
                    ])
                  }), 64))
                ]),
                _createElementVNode("div", { class: "px-3.5 pb-3.5" }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(STRIPE_BUTTON_CLASS),
                    onClick: connect
                  }, "Connect with Stripe"),
                  _cache[8] || (_cache[8] = _createElementVNode("p", { class: "m-0 mt-2.5 text-xs leading-relaxed text-catering-ink-500" }, " Opens Stripe in a new tab and takes about five minutes. Checkout stays closed until this is connected, so no orders can reach you before then. ", -1))
                ])
              ], 64))
    ]),
    (checkError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(checkError.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      (status.value !== _unref(STRIPE_CONNECTED))
        ? (_openBlock(), _createBlock(NeueButton, {
            key: 0,
            type: "cream",
            size: "sm",
            loading: checking.value,
            onClick: check
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(awaiting.value ? 'I have finished on Stripe' : 'Check again'), 1)
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      (status.value === _unref(STRIPE_CONNECTED) && !__props.complete)
        ? (_openBlock(), _createBlock(GlowFrame, {
            key: 1,
            subtle: "",
            "frame-class": "inline-flex rounded-full"
          }, {
            default: _withCtx(() => [
              _createVNode(NeueButton, {
                type: "accent",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('done')))
              }, {
                "icon-right": _withCtx(() => [
                  _createVNode(SwooshArrow, { class: "ml-1" })
                ]),
                default: _withCtx(() => [
                  _cache[9] || (_cache[9] = _createTextVNode(" Continue ", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}